module.exports = __webpack_public_path__ + "6b7b97f833433a4857ba8478ba86d3bd.png";